import { render, staticRenderFns } from "./Motorbikes.vue?vue&type=template&id=da95e956&"
import script from "./Motorbikes.vue?vue&type=script&lang=js&"
export * from "./Motorbikes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports